export const DEFAULT_NOTIFICATION_DURATION = 8000;
